import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './input.css';

/**
 * Input field allow users to enter single line text.
 * Input text supports all html5 behaviour and attributes depending upon browser support of html5.
 */
export default class Input extends Component {
	/**
	 * constants
	 */
	static get NORMAL () {
		return 'normal';
	}

	static get UNDERLINE () {
		return 'underline';
	}

	render () {
		const {
			className,
			inputStyle,
			...otherProps
		} = this.props;

		const inputClass = cx([`body-small pad-05r`], {
			[`bdr-rad4 ${style.defInp}`]: inputStyle === Input.NORMAL,
			[`text-center ${style.bottomBdr}`]: inputStyle === Input.UNDERLINE
		}, className);

		return (
			<input {...otherProps} className={inputClass} />
		);
	}
}

Input.propTypes = {
	/**
	 * css style of the input.
	 */
	className: PropTypes.string,

	/**
	 * inputStyle defines borders of input, Default is all side border. underline means border at bottom  and center align text.
	 */
	inputStyle: PropTypes.oneOf([Input.NORMAL, Input.UNDERLINE])
};

Input.defaultProps = {
	className: '',
	inputStyle: Input.NORMAL
};
